export const tilPengerFormat = (verdi: number, locale: string): string => {
    return new Intl.NumberFormat(locale, {
        style: 'decimal',
        maximumFractionDigits: 0,
    }).format(verdi);
};

export const fraPengerFormat = (formatertSomPenger: string, locale: string): string => {
    if (locale.startsWith('en')) {
        // Fjerner tusenskilletegn , og spaces
        return formatertSomPenger.replace(/\s+|,+/g, '');
    }

    // for nn-NO og nb-NO er tusenskilletegn mellomrom
    return formatertSomPenger.replace(/\s+/g, '');
};

export const tilDatoManed = (dato: Date, locale: string): string => {
    return new Intl.DateTimeFormat(locale, {
        month: 'long',
        day: 'numeric',
    }).format(dato);
};

export const tilDagOgManed = (mnd: number, dag: number, locale: string): string => {
    const dato: Date = new Date(new Date().getFullYear(), mnd, dag);
    return new Intl.DateTimeFormat(locale, {
        month: 'long',
        day: 'numeric',
    }).format(dato);
};

